'use client'

import { LegalConfirmation } from 'legal/components/policies/RegistryLegalPolicy/legal-confirmation/LegalConfirmation'

import { FormFieldIds, FormFieldNames } from '../../../constants'

export function FooterLegalConfirmation() {
	return (
		<LegalConfirmation
			id={FormFieldIds.LegalConfirmation}
			name={FormFieldNames.LegalConfirmationCheckbox}
			labelKeys={{
				checkbox: 'legal.checkbox',
				title: 'subscribe.legal.title',
				body: 'subscribe.legal.bodycopy',
				errorMessage: 'legal.checkbox.errormessage',
			}}
			required
		/>
	)
}
